import { lazy } from 'react';

// Group related routes for better chunk organization
export const AuthRoutes = {
  LoginPage: lazy(() => import('../auth/pages/LoginPage')),
  RegisterPage: lazy(() => import('../auth/pages/RegisterPage')),
  ForgotPassword: lazy(() => import('../auth/pages/ForgotPassword')),
};

export const MainRoutes = {
  HomePage: lazy(() => import('../pages/HomePage')),
  DashboardCard: lazy(() => import('../pages/DashboardCard')),
  AboutTanzaniaPage: lazy(() => import('../pages/AboutTanzaniaPage')),
};

export const DataroomRoutes = {
  Overview: lazy(() => import('../pages/Dataroom/OverviewPage')),
  ClimateIndicators: lazy(() => import('../pages/Dataroom/ClimateIndicatorsPges')),
  ClimateProfile: lazy(() => import('../pages/Dataroom/ClimateProfilePage')),
  ClimateImpacts: lazy(() => import('../pages/Dataroom/ClimateImpactsPage')),
  Economics: lazy(() => import('../pages/Dataroom/EconomicsPage')),
  AdaptationOptions: lazy(() => import('../pages/Dataroom/AdaptationOptionsPage')),
  RiskIndices: lazy(() => import('../pages/Dataroom/RiskIndicesPage')),
  RiskAssessment: lazy(() => import('../pages/RiskAssessmentPage')),
  HistoricalPeriodPage: lazy(() => import('../pages/Dataroom/ClimateProfile/HistoricalPeriodPage')),
};

export const AdminRoutes = {
  UserManagement: lazy(() => import('../pages/Admin/UserManagementPage')),
  Log: lazy(() => import('../pages/Admin/LogPage')),
};